import React from "react";
import { BiErrorCircle } from "react-icons/bi";
import { FiAlertTriangle } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { SubscriptionStatus } from "src/contexts/subscription.status";
import "./styles.css";
interface SubscriptionWarningProps {
  flag: SubscriptionStatus;
}

const SubscriptionWarning: React.FC<SubscriptionWarningProps> = ({ flag }) => {
  const navigate = useNavigate();

  if (!flag) {
    return null; // Não renderiza nada se a flag for undefined
  }

  const Content = {
    NEW_USER_TOLERANCE: {
      classname: "alert-card",
      Icon: <BiErrorCircle />,
      message: (
        <>
          Bem vindo a Hype Fit
          <br />
          Assine para aproveitar todos os recursos!
        </>
      ),
    },
    PENDING_PAYMENT: {
      classname: "warning-card",
      Icon: <FiAlertTriangle />,
      message: (
        <>
          Pagamento Pendente!
          <br />
          Por favor, atualize suas informações de pagamento para evitar
          cancelamento da assinatura.
        </>
      ),
    },
    SUBSCRIPTION_REQUIRED: {
      classname: "error-card",
      Icon: <FiAlertTriangle />,
      message: (
        <>
          Sua assinatura está expirada.
          <br />
          Clique para regularizar assinatura!
        </>
      ),
    },
  };

  const rend = Content[flag];

  return (
    <button
      onClick={() => navigate("/settings")}
      className="col-span-1 w-full flex-col p-2 md:col-span-3"
    >
      <div className={rend.classname}>
        {rend.Icon}
        <div className="text-sm">
          <p className={`text-center font-semibold`}>{rend.message}</p>
        </div>
      </div>
    </button>
  );
};

export default SubscriptionWarning;
